"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadgedAvatarMixin = void 0;
var _styledComponents = require("styled-components");
var _AvatarBadge = require("../../components/AvatarBadge/AvatarBadge.styles");
/** @class BadgedAvatarMixin */
/** @method */
var BadgedAvatarMixin = /*#__PURE__*/(0, _styledComponents.css)(["display:inline-block;position:relative;", "{position:absolute;bottom:0;right:0;}"], _AvatarBadge.StyledAvatarBadge);
exports.BadgedAvatarMixin = BadgedAvatarMixin;